import { Component } from '@angular/core';

@Component({
  selector: 'app-bandwidth-tooltip',
  templateUrl: './bandwidth-tooltip.component.html',
  styleUrls: ['./bandwidth-tooltip.component.scss'],
})
export class BandwidthTooltipComponent {}
